// VMCreationErrorModal.jsx with updated styling and behavior
import React from 'react';
import { Modal, Button, Message } from 'semantic-ui-react';

const VMCreationErrorModal = ({
    open,
    onClose,
    error,
    errorLocation,
    requestId,
    cloudName,
    cloudNameLabel = 'Cloud Name'
}) => {
    if (!error) return null;

    return (
        <Modal
            open={open}
            onClose={onClose}
            size="small"
            className="error-modal"
        >
            <Modal.Header style={{
                backgroundColor: '#FEF2F2',
                color: '#CE1B4E',
                borderBottom: '1px solid #FECACA'
            }}>
                VM Creation Failed
            </Modal.Header>
            <Modal.Content>
                <Message negative>
                    <Message.Header>Error in {errorLocation}</Message.Header>
                    <div style={{ marginTop: '15px' }}>
                        <p><strong>Request ID:</strong> {requestId}</p>
                        <p><strong>{cloudNameLabel}:</strong> {cloudName}</p>
                        <div style={{ marginTop: '10px' }}>
                            <p><strong>Error Details:</strong></p>
                            <div style={{
                                backgroundColor: '#FEF2F2',
                                padding: '12px',
                                borderRadius: '6px',
                                color: '#CE1B4E',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                                fontFamily: 'monospace',
                                fontSize: '14px',
                                maxHeight: '200px',
                                overflowY: 'auto',
                                border: '1px solid #FECACA'
                            }}>
                                {error}
                            </div>
                        </div>
                    </div>
                    <p style={{ marginTop: '15px', fontWeight: 'bold' }}>
                        All created resources have been automatically cleaned up.
                    </p>
                    <p style={{ marginTop: '5px' }}>
                        A detailed error report has been sent to all approvers.
                        The request has been marked as failed.
                    </p>
                    <p style={{ marginTop: '10px', fontStyle: 'italic' }}>
                        You can view the complete logs behind this error message.
                    </p>
                </Message>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    color="red"
                    onClick={onClose}
                    icon="close"
                    content="Close"
                    style={{
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}
                />
            </Modal.Actions>
        </Modal>
    );
};

export default VMCreationErrorModal;